import React from 'react';
import "./assets/sass/styles.scss";
import "./assets/sass/contarst.scss";
import CustomRouter from './routes/Router';

function App() {

  return (
    <CustomRouter />
  );
}


export default App;
